import { createClient } from "@supabase/supabase-js";

const supabaseUrl = ((typeof process !== "undefined" ? process.env.BUN_PUBLIC_SUPABASE_URL : "") || "https://zihqlfxonflidjspkabb.supabase.co") as string;
const supabaseAnonKey = ((typeof process !== "undefined" ? process.env.BUN_PUBLIC_SUPABASE_ANON_KEY : "") || "") as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
    },
    realtime: {
        params: {
            eventsPerSecond: 10,
        },
        heartbeatIntervalMs: 15000,
        reconnectAfterMs: (tries: number) => {
            return Math.min(1000 * Math.pow(2, tries), 30000);
        },
    },
    global: {
        headers: {
            'x-client-info': 'assistente-educacional',
        },
    },
});